import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useBusinessManualsCategoryStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const BusinessManualsCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable screen="business_manuals" recordType="status" />
      <CategoryStatusTable screen="business_manuals" recordType="category" />
    </Styles>
  );
};

const BusinessManualsCategoryStatus: FC<ReceivedProps> = (props) => (
  <BusinessManualsCategoryStatusLayout
    {...useBusinessManualsCategoryStatus(props)}
  />
);

export default BusinessManualsCategoryStatus;
